import {Injectable} from '@angular/core';
import {MutableHttp} from '../../../../common/core/http';
import {CookiesManager} from '../cookies/cookies.manager';
import {TOKEN_HEADER} from '../../../../common/constants';
import {ConnectionBackend, Headers, RequestOptions, RequestOptionsArgs, Response} from '@angular/http';

@Injectable()
export class ClientHttp extends MutableHttp {

    constructor(backend: ConnectionBackend, defaultOptions: RequestOptions) {
        super(backend, defaultOptions);
    }

    protected modifyOptions(options?: RequestOptionsArgs): RequestOptionsArgs {
        if (options == null) {
            options = new RequestOptions();
        }

        if (options.headers == null) {
            options.headers = new Headers();
        }

        this.trySetTokenHeader(options.headers);

        return options;
    }


    protected modifyResponseCallback(): (response: Response) => Response {
        return (response: Response) => {
            if (response && response.headers) {
                if (response.headers.has(TOKEN_HEADER)) {
                    CookiesManager.setToken(response.headers.get(TOKEN_HEADER))
                }
            }

            return response;
        };
    }

    private trySetTokenHeader(headers: Headers) {
        if (CookiesManager.isTokenExist()) {
            headers.append(TOKEN_HEADER, CookiesManager.getToken());
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/clients/app/core/http/client.http.ts